import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetDeleteSmsDraft(club, id) {

  var url = "/sms_api/delete_sms_reservation_draft/" + club + "/" + id; 
  var response = FetchGetDataWithAuthNEW(url);

  return response
}